// Evaluation type identifiers
export const EvaluationType = {
  INLANDSVERSAND: 'inlandsversand',
  VERSANDSTATISTIK: 'versandstatistik',
  GEBIETSAUFNAHME: 'gebietsaufnahme',
  ZEMENTVERWENDUNG: 'zementverwendung',
  ZEMENTARTEN: 'zementarten',
} as const;
export type EvaluationType =
  (typeof EvaluationType)[keyof typeof EvaluationType];

// Display labels (German)
export const EvaluationTypeLabels: Record<EvaluationType, string> = {
  [EvaluationType.INLANDSVERSAND]: 'Inlandsversand',
  [EvaluationType.VERSANDSTATISTIK]: 'Versandstatistik',
  [EvaluationType.GEBIETSAUFNAHME]: 'Gebietsaufnahme',
  [EvaluationType.ZEMENTVERWENDUNG]: 'Zementverwendung',
  [EvaluationType.ZEMENTARTEN]: 'Zementarten',
};

// Periodicity labels (German)
export const EvaluationPeriodicity: Record<EvaluationType, string> = {
  [EvaluationType.INLANDSVERSAND]: 'monatlich',
  [EvaluationType.VERSANDSTATISTIK]: 'quartalsweise',
  [EvaluationType.GEBIETSAUFNAHME]: 'quartalsweise',
  [EvaluationType.ZEMENTVERWENDUNG]: 'jährlich',
  [EvaluationType.ZEMENTARTEN]: 'jährlich',
};
